
// WebpackRequireFrom
Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof publicUrl !== "string") {
    throw new Error("WebpackRequireFrom: 'publicUrl' is not a string or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return publicUrl;
} catch (e) {
  if (!true) {
    console.error(e);
  }
  return "https://wallet.startwaves.co/";
}
 },
  set: function () {}
});